import axios from "axios";
import RefreshTokenHandler from "../refreshToken/refreshToken";
import Config from "../config";

export const getRoleByName = async (email, role) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/role/by-name?email=${email}&role=${role}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getRoleByName(email, role);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};
